/** @flow */

import { put, takeEvery, call, all } from "redux-saga/effects";
import http from "@http";
import actionCreators from "@modules/management/actionCreator";
import type { Action } from "redux-action";
import {
  GetCallbackScheduledWindows,
  UpdateCallbackScheduledWindows,
  UpdateCallbackScheduledWindowsSuccess,
} from "@modules/management/constants/actions";
import { sendSuccessMessage } from "@modules/app/actionCreator";

type ScheduledWindowsResponse = {
  scheduledWindows: Array<Object>,
};

export function* onGetCallbackScheduledWindows(): Generator<
  *,
  void,
  { data: ScheduledWindowsResponse },
> {
  try {
    const response = yield call(http.get, "/api/v1/contact-centre/callback-scheduled-windows");

    yield put(actionCreators.GetCallbackScheduledWindowsSuccess(response.data.scheduledWindows));
  } catch (e) {
    yield put(actionCreators.GetCallbackScheduledWindowsError(e.response));
  }
}

export function* onUpdateCallbackScheduledWindows({
  payload,
}: Action<ScheduledWindowsResponse>): Generator<*, void, Array<any>> {
  try {
    yield call(http.put, "/api/v1/contact-centre/callback-scheduled-windows", {
      scheduledWindows: (payload || {}).scheduledWindows || [],
    });

    yield all([
      put(actionCreators.UpdateCallbackScheduledWindowsSuccess()),
      put(sendSuccessMessage("CALLBACK_QUEUE_UPDATED")),
    ]);
  } catch (e) {
    yield put(actionCreators.UpdateCallbackScheduledWindowsError(e.response));
  }
}

export function* QueueManagementSaga(): Generator<*, void, void> {
  yield takeEvery(
    [GetCallbackScheduledWindows, UpdateCallbackScheduledWindowsSuccess],
    onGetCallbackScheduledWindows,
  );
  yield takeEvery(UpdateCallbackScheduledWindows, onUpdateCallbackScheduledWindows);
}

export default QueueManagementSaga;
